import { Col, Form, Input, Row } from 'antd'
import CustomSpin from 'elements/CustomSpin'
import FormSectionTitle from 'elements/FormSectionTitle'
import { defaultFormItemLayout, rules } from 'modules/FormItems'
import { strVal } from 'modules/Utils'
import React from 'react'

function BrandsForm(props) {
  const { fetching, object, isNew } = props

  const { getFieldDecorator, setFieldsValue, getFieldValue } = props.form

  return (
    <CustomSpin spinning={fetching}>
      <Form>
        <Row>
          <FormSectionTitle title={'Details'} />
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Brands Name">
              {getFieldDecorator('name', {
                initialValue: strVal(object, 'name'),
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Brand URL">
              {getFieldDecorator('url', {
                initialValue: strVal(object, 'url'),
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Logo URL">
              {getFieldDecorator('logo', {
                initialValue: strVal(object, 'logo'),
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Facebook Link">
              {getFieldDecorator('facebook', {
                initialValue: strVal(object, 'facebook'),
              })(<Input />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Privacy Link">
              {getFieldDecorator('privacy', {
                initialValue: strVal(object, 'privacy'),
              })(<Input />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="linkedIn Link">
              {getFieldDecorator('linkedIn', {
                initialValue: strVal(object, 'linkedIn'),
              })(<Input />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Phone">
              {getFieldDecorator('phone', {
                initialValue: strVal(object, 'phone'),
              })(<Input />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Address">
              {getFieldDecorator('address', {
                initialValue: strVal(object, 'address'),
              })(<Input.TextArea />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </CustomSpin>
  )
}

export default Form.create()(BrandsForm)
